import { useQuery } from '@tanstack/react-query'

import { CLIENT_LOCALE } from '@/lib/client-locale'
import {
  emptyEmployerPostingPreferences,
  type EmployerPostingPreferences,
} from '@/lib/employer-posting-preferences'
import { loadOrganisationPostingPreferences } from '@/lib/employer-posting-preferences-api'
import { defaultEntityCountryCode } from '@/utils/entity-location-fields'

export const organisationPostingPreferencesQueryKey = (slug: string) =>
  ['organisation-posting-preferences', slug] as const

export function useOrganisationPostingPreferences(slug: string | undefined) {
  const defaultCountry = defaultEntityCountryCode(CLIENT_LOCALE)

  return useQuery({
    queryKey: organisationPostingPreferencesQueryKey(slug ?? ''),
    queryFn: async (): Promise<EmployerPostingPreferences> => {
      if (!slug?.trim()) {
        return emptyEmployerPostingPreferences(defaultCountry)
      }
      return loadOrganisationPostingPreferences(slug.trim(), defaultCountry)
    },
    enabled: !!slug?.trim(),
  })
}
